import FocusedPOIComponents from '@alltrails/maps/components/POI/FocusedPOIComponents/FocusedPOIComponents';
import type { TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import { useNavigateBack } from '@/hooks/useNavigateBack';
import { useAppSelector } from '@/utils/redux';

const FocusedPOIMapComponents = () => {
  const returnToExplore = useNavigateBack(undefined /* fallbackUrl */, { preserveCurrentBounds: true });
  const { poi, searchResults, searchResultsPlace } = useAppSelector(state => ({
    poi: state.explorePOI.poi,
    searchResults: state.exploreService.searchResults,
    searchResultsPlace: state.exploreService.searchResultsPlace
  }));

  let trails = [] as TrailSearchResult[];
  if (poi && searchResults && 'ID' in poi && poi.ID === searchResultsPlace?.ID) {
    trails = searchResults.filter(result => result.type === 'trail') as TrailSearchResult[];
  }

  return <FocusedPOIComponents poi={poi} trails={trails} onPinClick={returnToExplore} shouldHidePhoto />;
};

export default FocusedPOIMapComponents;
